import React from 'react';
import ReactDOM from 'react-dom';
import { DivOverallWrap } from '../../../../react/components/utility/wrap';
import { Terms } from '../../../../react/pages/legal/terms/terms';


document.addEventListener('DOMContentLoaded', () => {
  const domToBinding = document.getElementById('react-legal-terms-root')!;
  if(domToBinding == null) return

  ReactDOM.render(
    <div style={{backgroundColor: '#f0f0f0'}}>
      <DivOverallWrap style={{paddingBottom: 0, backgroundColor: '#f0f0f0'}}>
        <Terms/>
      </DivOverallWrap>
    </div>,
    domToBinding);
});

